import type { ColumnProps } from 'antd/lib/table';

import { SummaryGroupByLabelsMap } from '@/components/reporting/summary-group-by';
import {
  createAmountColumn,
  createNumericColumn,
  createStringColumn,
} from '@/components/table/columns';
import { summaryGroupByValueFormatter } from '@/resources/channels/performance-summary/shared/formatters';

export const creditCardFunnelTableConfig = (
  groupBy: string
): Array<ColumnProps<any>> => [
  createStringColumn({
    key: 'groupKey',
    render: summaryGroupByValueFormatter,
    title: SummaryGroupByLabelsMap[groupBy],
  }),
  createNumericColumn({
    align: 'right',
    key: 'numLeads',
    title: 'Leads',
  }),
  createNumericColumn({
    align: 'right',
    key: 'numLeadsSubmittedApp',
    title: 'Submitted Applications',
  }),
  createNumericColumn({
    align: 'right',
    key: 'numLeadsClicked',
    title: 'Unique Offer Clicks',
  }),
  createNumericColumn({
    align: 'right',
    key: 'numLeadsApproved',
    title: 'Approvals',
  }),
  createAmountColumn({
    align: 'right',
    key: 'totalPayout',
    title: 'Attributed Earnings',
  }),
];
